import React from 'react'
import {Text, TextTypography} from 'wix-ui-tpa/cssVars'
import {classes} from './page-title.st.css'

export const PageTitle = props => (
  <Text typography={TextTypography.largeTitle} {...props} className={classes.root} tagName="h2" />
)
